import { useQuery } from '@tanstack/react-query';
import { jobApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Every job the user can see with its posts embedded, for the global Activity page. */
export function useActivityFeed() {
  return useQuery({
    queryKey: queryKeys.posts.activityFeed(),
    queryFn: ({ signal }) =>
      jobApiClient.getActivityFeed(toCancelToken(signal)),
    meta: { errorContext: 'activity feed' },
  });
}
